import { useHubTranslationContext } from '@/utils/i18n/HubTranslationProvider';
import type { HubTranslationContextValue } from '@/utils/i18n/types';

export default function useHubTranslation(): HubTranslationContextValue {
  return useHubTranslationContext();
}
